<template>
  <div class="SimpleTable border d-flex">
    <table>
      <thead class="d-flex">
        <tr class="d-flex">
          <th v-for="(col, index) in columns"
            class="py-1 px-2"
            :key="index"
          >
            {{ col }}
          </th>
        </tr>
      </thead>
      <tbody>
        <slot name="before-first-row"></slot>

        <tr v-for="(row, index) in computedData" class="d-flex" :key="index">
          <td v-for="(field, index) in variables"
            class="py-1 px-2"
            :key="index"
            :style="{width: isReady ? `${clientWidth}px` : 'auto'}"
          >
            <span v-if="!isReady" class="ske">
              thsa thatsa tha th
            </span>
            <slot v-else
              :name="`cell-${field}`"
              :value="row[field]"
            >
              <span>
                {{ row[field] }}
              </span>
            </slot>
          </td>

          <td class="py- px-2">
            <slot name="row-action" :item="field"></slot>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: {
    data: Array,
    columns: Array,
    variables: Array,
    loading: Boolean,
  },
  data() {
    return {
      clientWidth: 0,
    }
  },
  mounted() {
    this.calculateTheadCellWidths()
    this.interval = setInterval(() => this.calculateTheadCellWidths(), 300)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    calculateTheadCellWidths() {
      const width = document.querySelector(".SimpleTable th").clientWidth
      if (width && this.clientWidth !== width) this.clientWidth = width
    },
  },
  computed: {
    isReady() {
      return !this.loading && this.data && this.data.length && this.clientWidth
    },
    computedData() {
      if (this.isReady) return this.data
      return [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    },
  },
}

</script>

<style scoped>

.SimpleTable {
  border-radius: 4px;
}

tr + tr {
  border-top: 1px solid #EFEFF0;
}

thead tr {
  border-bottom: 1px solid #dee2e6;
}


th, tr, td, table {
  flex-basis: 100%;
}

th, td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

td + td, th + th {
  border-left: 1px solid #EFEFF0;
}

td {
  background-color: #FBFBFB;
}

thead th + th {
  border-left: 1px solid #dee2e6;
}

</style>
